const WIDTH: Record<string, string> = {
  'size-3': 'w-6',
  'size-3.5': 'w-6',
  'size-4': 'w-8',
  'size-5': 'w-10',
  'size-6': 'w-14',
  'size-8': 'w-24',
  'size-12': 'w-32',
}

/**
 * Indeterminate loading: a short bar that fills left to right over and
 * over, never a circle (John's rule, Oct 29 2026). Call sites still pass a
 * size-* class from the spinner days; it picks the bar's width.
 */
export function Spinner({ className = '' }: { className?: string }) {
  const size = className.match(/\bsize-[\d.]+\b/)?.[0]
  const rest = className.replace(/\bsize-[\d.]+\b/g, '').trim()
  return (
    <span
      className={`loading-bar inline-block h-1.5 align-middle ${size ? WIDTH[size] ?? 'w-10' : 'w-10'} ${rest}`}
      role="progressbar"
      aria-label="Loading"
    />
  )
}
